<template>
  <el-table-column v-bind="$attrs" v-on="$listeners">
    <rc-table-item
      v-for="child in comChildren"
      :key="child.prop"
      v-bind="child"
    >
      <template v-for="(_index, name) in $scopedSlots" :slot="name" slot-scope="scope">
        <slot :name="name" v-bind="scope" :index="_index"></slot>
      </template>
    </rc-table-item>
    <template slot="header" slot-scope="scope">
      <slot :name="`header${strFirstWith($attrs.prop)}`" v-bind="scope">
        {{ $attrs.label }}
      </slot>
    </template>
    <template slot-scope="scope">
      <slot v-bind="scope"></slot>
    </template>
  </el-table-column>
</template>

<script>
import { strFirstWith } from "@/utils";
import RcTableItem from "../RcTableItem";

export default {
  name: "RcTableItem",
  components: {
    RcTableItem
  },
  props: {
    replaceFields: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      replaceFieldsDef: {
        children: "children"
      }
    };
  },
  computed: {
    comAttr() {
      return this.$attrs;
    },
    comChildren() {
      return this.comAttr && this.comAttr[this.comReplaceFields.children];
    },
    comReplaceFields() {
      return { ...this.replaceFieldsDef, ...this.replaceFields };
    }
  },
  methods: {
    strFirstWith
  }
};
</script>

<style>
</style>
